import React from "react";
import { CONTAINER_TEMPLATES } from "./ContainerTemplates";

export function LayoutPicker({ onSelect }) {
  return (
    <div style={{
      display: "flex",
      gap: "8px",
      background: "#fff",
      border: "1px solid #ddd",
      borderRadius: 8,
      padding: 8,
      boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
      zIndex: 99,
      position: "absolute"
    }}>
      {CONTAINER_TEMPLATES.map(t => (
        <button
          key={t.id}
          onClick={() => onSelect(t)}
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${t.columns}, 1fr)`,
            width: 60,
            height: 40,
            border: "1px solid #ccc",
            padding: 3,
            cursor: "pointer",
            borderRadius: 4,
            background: "#f9fafb"
          }}
        >
          {Array.from({ length: t.columns }).map((_, i) => (
            <div
              key={i}
              style={{
                background: "#d1d5db",
                borderRadius: "2px",
              }}
            />
          ))}
        </button>
      ))}
    </div>
  );
}
